import {Org} from "../../resources/org"
import {BillpayOrgSettings} from "../../resources/billpayOrgSettings"

export function getOrgId(settings: BillpayOrgSettings): string | undefined {
	return settings.relationships?.org?.data?.id
}

export function buildOrgNameMap(orgs: Org[]): Map<string, string> {
	return new Map(orgs.map((org) => [org.id, org.attributes.name]))
}
